import React from "react";
import { Helmet } from "react-helmet-async";
import "./TrainingAndExperiences.css";

function TrainingAndExperiences() {
    return (
        <div>
<Helmet>
  <title>Training & Experience | Adya Yoga</title>
  <meta
    name="description"
    content="Certifications, meditation practice and energy therapies facilitated by Jigyasa at Adya Yoga."
  />
  <link rel="canonical" href="https://yogaadya.com/training-and-experiences" />
  <meta name="robots" content="index, follow" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Adya Yoga" />
  <meta property="og:title" content="Training & Experience | Adya Yoga" />
  <meta property="og:description" content="Yoga trainer certifications, meditation, and energy practices by Jigyasa." />
  <meta property="og:url" content="https://yogaadya.com/training-and-experiences" />
  <meta property="og:image" content="https://yogaadya.com/assets/images/YogaTrainer.webp" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Training & Experience | Adya Yoga" />
  <meta name="twitter:description" content="Yoga trainer certifications, meditation, and energy practices." />
  <meta name="twitter:image" content="https://yogaadya.com/assets/images/YogaTrainer.webp" />
</Helmet>
<section className="py-md-3 py-sm-3 py-3" id="service">
<div className="events-retreats-container">
      {/* Header Section */}
      <div className="events-header">
                    <h1 className="events-title">Experience of Yoga</h1>
                    <p className="events-subtitle">
                    Yoga, Energy Reading & Healing. Flower Essences & Animal Communication
                    </p>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6 service-grid-tree text-center">
          <div className="ser-fashion-grid">
            <div className="about-icon mb-md-4 mb-3">
            <img src="assets/images/YogaTrainer.webp" alt="Yoga Trainer" class="therapy-img"/>
            </div>
            <div className="ser-sevice-grid">
              <h4 className="pb-3">Yoga Trainer Certifications</h4>
              <p>
              <ul className="bullets">
  <li>Teacher Training Hatha Yoga at Mysore Hatha Yoga Kendra</li>
  <li>Teacher Training Ashtanga Vinyasa Yoga at Ashtanga Yoga Institute, Mysore</li>
  <li>Intensive Saadhna at Mysore Hatha Yoga Kendra</li>
  <li>Short term Yoga Saadhna from Rishikesh, India</li>
  <li>Teacher Training Intensive at Vedansha Institute of Vedic Science &amp; Alternative Medicine</li>
  <li>Restorative Yoga Teacher Training with Judith Hanson Lasater &amp; Lizzie Lasater</li>
</ul>

              </p>
              {/* <p>Teacher Training Hatha Yoga at Mysore Hatha Yoga Kendra <br></br>
                Teacher Training Ashtanga Vinyasa Yoga at Ashtanga Yoga Institute, Mysore <br></br>
                Intensive Saadhna at Mysore Hatha Yoga Kendra <br></br>
                Short term Yoga Saadhna from Rishikesh, India. <br></br>
                Teacher Training Intensive at Vedansha Institute of Vedic Science &amp; Alternative
                Medicine <br></br>
                Restorative Yoga Teacher Training with Judith Hanson Lasater &amp; Lizzie Lasater <br></br>
            </p> */}
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6 service-grid-tree text-center">
          <div className="ser-fashion-grid">
            <div className="about-icon mb-md-4 mb-3">
            <img src="assets/images/Meditation.webp" alt="Meditation Expertise" class="therapy-img"/>
            </div>
            <div className="ser-sevice-grid">
              <h4 className="pb-3">Meditation Practice</h4>
              <p>Practitioner of Kundalini &amp; Chakra Meditation, Sri Vidya Saadhna for last 15 years. <br></br>
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6 service-grid-tree text-center">
          <div className="ser-fashion-grid">
            <div className="about-icon mb-md-4 mb-3">
            <img src="assets/images/EnergyPractices.webp" alt="Energy Practices" class="therapy-img"/>
            </div>
            <div className="ser-sevice-grid">
              <h4 className="pb-3">Energy Practices</h4>
              <p><b>Aura Scan &amp; Energy Consultation</b> <br></br>
                    <b>Chakra Balancing.</b> <br></br>
                    <b>Reiki</b> Certified as a Master in Reiki. Have been healing and teaching Reiki as a
                    healing technique. <br></br>
                    <b>Pranic Healing</b> Certified as Advanced Pranic Healer and Psychotherapist. <br></br>
                    <b>Crystal Healing</b>. Using crystals to heal and help in a person's health and wellbeing. <br></br>
                    <b>Flower Essence Therapist</b> Certified as a flower essence therapist from Australia. <br></br>
                    <b>Animal Communication</b> Master Level Certification from The Animal Talk Institute,
                    Australia. <br></br>
                    <b>Past Life Healing Therapist</b> training under guidance of Kumar from Mumuksha,
                    Mysore. <br></br>
                    <b>Sound Healing Facilitator</b> training at Aithein School, Goa <br></br>
                </p>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </section>
        </div>
    )
}

export default TrainingAndExperiences